<template>
  <div class="u-hide-print">
    <h2>Verder praten?</h2>
    <div v-if="!done">
      <p>Vul hier het telefoonnummer van de contactpersoon van je gemeente in om door te praten</p>
      <form @submit.prevent="onSubmit" novalidate>
        <div class="fsRow">
          <div class="fsRowBody fsCell fsFieldCell">
            <label class="fsLabel">
              Uw telefoonnummer
              <span class="fsRequiredMarker">*</span>
            </label>

            <b-input
              type="email"
              id="input-2"
              v-model="phone"
              :class="{'hasError': $v.phone.$error}"
              required
            />
            <div class="error" v-if="$v.phone.$error">Vul je telefoonnummer in</div>
          </div>
        </div>
        <p
          v-if="formError"
          class="error"
        >Het fomulier kon niet worden verzonden, probeer het opnieuw</p>
        <button type="submit">Bel mij</button>
      </form>
    </div>
    <div v-else>
      <p>Bedankt! We nemen binnenkort contact met je op.</p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      phone: "",
      done: false,
      formError: false
    };
  },
  methods: {
    onSubmit() {
      this.formError = false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        axios
          .post("https://kernwaarden.protestantsekerk.nl/phoneme/", {
            phone: this.phone,
            email: this.$store.state.email,
            token: this.$store.state.token
          })
          .then(response => {
            if (response.data.result == "ok") {
              this.done = true;
            } else this.formError = true;
          })
          .catch(error => {
            if (error.response) {
              this.formError = true;
            }
          });
      }
    }
  },
  validations: {
    phone: {
      required
    }
  }
};
</script>
